<script setup lang="ts">
import { resolveRouteName } from '@/utils/utils'

defineProps(['upperFooterData'])
</script>
<template>
  <div class="3xl:min-w-[255px flex flex-col lg:min-w-[170px] md:items-center">
    <ul class="leading-normal 3xl:text-lg">
      <p
        class="mb-[40px] lg:mb-[20px] text-lg lg:leading-[24px] leading-normal lg:text-xl lg:font-bold"
      >
        {{ upperFooterData?.footer_column_three_title }}
      </p>
      <li class="mb-[20px] lg:mb-[10px]">
        <a
          :href="resolveRouteName(upperFooterData?.footer_column_three_links?.[0]?.link)"
          class="leading-normal hover:underline"
          >{{ upperFooterData?.footer_column_three_links?.[0]?.label }}</a
        >
      </li>
      <li class="mb-[20px] lg:mb-[10px]">
        <a
          class="leading-normal hover:underline"
          :href="'/cookies-policy.pdf'"
          :target="upperFooterData?.cookie_policy_label"
          >{{ upperFooterData?.cookie_policy_label }}</a
        >
      </li>
      <li class="mb-[20px] lg:mb-[10px]">
        <a
          class="leading-normal hover:underline"
          :target="upperFooterData?.cookie_policy_label"
          :href="'/privacy-policy.pdf'"
        >
          {{ upperFooterData?.privacy_policy_label }}
        </a>
      </li>
      <li class="mb-[20px] lg:mb-[10px]">
        <a
          class="leading-normal hover:underline"
          :target="'/HMM-Terms-and-Conditions.pdf'"
          :href="'/HMM-Terms-and-Conditions.pdf'"
          >{{ upperFooterData?.terms_and_conditions_label }}</a
        >
      </li>
    </ul>
  </div>
</template>
